import { jsx as _jsx } from "react/jsx-runtime";
import ChipMUI from "@mui/material/Chip";
export const Chip = (props) => {
    return _jsx(ChipMUI, Object.assign({ size: "small", color: "primary" }, props));
};
export default Chip;
